const LOCATIONS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
  hotkeys: {
    selectedRowKey: undefined,
    selectedCellKey: undefined,
    isHotkeyEditModeEnabled: false,
  },
}

export default LOCATIONS_INITIAL_STATE
